import React, { useEffect, useState } from "react";

interface Privilege {
    object: { name: string };
    type: { name: string };
}

interface UserPrivilegesProps {
    privileges: Privilege[];
}

const UserPrivileges: React.FC<UserPrivilegesProps> = ({ privileges }) => {
    const [objects, setObjects] = useState<Record<string, string[]>>({});

    useEffect(() => {
        setObjects(() => {
            const objMap: Record<string, string[]> = {};
            privileges.forEach(({ object, type }) => {
                if (!objMap[object.name]) {
                    objMap[object.name] = [];
                }
                if (!objMap[object.name].includes(type.name)) {
                    objMap[object.name].push(type.name);
                }
            });
            return objMap;
        });
    }, [privileges]);

    return (
        <div className="privileges-card mt-4">
            <div className="privileges-card-header">
                <h6>Privileges</h6>
            </div>
            <div className="privileges-card-body">
            <ul className="list-group list-group-flush privileges-list">
            {Object.entries(objects).map(([object, types]) => (
                <li key={object} className="px-3 privileges-list-item list-group-item px-0 d-flex justify-content-between">
                    <div className="left privilege-type">{object}</div>
                    <div className="d-flex justify-content-end align-items-center">
                        {types.map((v, i) => (
                            <div key={i} className="badge ms-2 p-2">
                                {v}
                            </div>
                        ))}
                    </div>
                </li>
            ))}
            </ul>
            </div>
        </div>
    )
};

export default UserPrivileges;